
import axios, { AxiosError, AxiosResponse } from "axios";
import { defineComponent, onMounted, ref, nextTick, inject } from 'vue';
import { decode } from "html-entities";
import VueScrollTo from 'vue-scrollto';

export default defineComponent({
    props: {
        action: {
            type: String,
            required: true,
        },
        onSuccess: {
            type: Function,
            default: null,
        },
        resetFormOnSuccess: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const action = ref(props.action)
        const form = ref<HTMLFormElement | null>(null);
        const scrollOffset = inject('scrollOffset');

        let htmlResponse = ref("");
        let isLoading = ref<Boolean>(false);
        let properties = {} as { [key: string]: any };


        onMounted(() => {
            form.value?.addEventListener("submit", (e) => {
                e.preventDefault();
                send();
            });
        })

        const getErrorMessage = (propertiesKeys: string) => {
            let messages: Array<string> = [];
            for (let property of propertiesKeys.split(",")) {
                property = property.trim();
                if (properties[property]) {
                    messages = messages.concat(properties[property].map((error: { message: string }) => error.message));
                }
            }
            return messages.join("<br>");
        };

        const handleErrorResponse = async (error: AxiosError) => {
            if (error.response) {
                properties = error.response.data;
                await nextTick();
                let firstErrorElement = form.value?.querySelector(".form-floating .is-invalid");
                if (firstErrorElement) {
                    VueScrollTo.scrollTo(firstErrorElement, {
                        offset: scrollOffset
                    });
                }
            } else {
                console.error("Oops an error occurred.");
            }
        };

        const handleSuccessResponse = (response: AxiosResponse) => {
            if (response.data && response.data.content) {
                htmlResponse.value = decode(response.data.content);
                nextTick(() => {
                    let firstSuccessElement = form.value?.querySelector(".contact-form-success");
                    if (firstSuccessElement) {
                        VueScrollTo.scrollTo(firstSuccessElement, {
                            offset: scrollOffset
                        });
                    }
                });
            }
            if (props.onSuccess) {
                props.onSuccess();
            }
            reset(props.resetFormOnSuccess);
        };

        const hasPropertyError = (propertiesKeys: string) => {
            for (let property of propertiesKeys.split(",")) {
                property = property.trim();
                if (properties[property] && properties[property].length) {
                    return true;
                }
            }
            return false;
        }

        const reset = (resetForm: boolean) => {
            properties = [];
            if (resetForm) {
                form.value?.reset();
            }
        };

        const send = () => {
            if (form.value) {
                let formData = new FormData(form.value);
                isLoading.value = true;
                axios.post(action.value, formData)
                    .then((response) => {
                        handleSuccessResponse(response);
                    })
                    .catch((error) => {
                        handleErrorResponse(error);
                    })
                    .then(() => {
                        isLoading.value = false;
                    });
            }
        };


        return {
            action, form, htmlResponse, isLoading, send, hasPropertyError, getErrorMessage
        }
    }
});
